import { createContext } from 'react';

export const Context = createContext();
export default Context;
